import { Component, HostListener, OnInit, computed, effect, inject } from '@angular/core';
import { AuthService } from './auth/services/auth.service';
import { AuthStatus } from './auth/interfaces';
import { Router, RouterOutlet } from '@angular/router';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RequestStatusService, TypeDocIDService, UsersService } from './sadi/services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatProgressBarModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'AppSadi';

  private authService   = inject( AuthService );
  private router        = inject( Router );
  private usersService          = inject( UsersService );
  private typeDocIDService      = inject( TypeDocIDService );
  private requestStatusService  = inject(RequestStatusService);
  private servicesInitialized = false;

  ngOnInit(): void {
   this.themeMode();
   this.setupDarkModeListener();
   this.authService.checkAuthStatus().subscribe({
    next: (authenticated) => {
      if (authenticated) {
        this.initializeServices();
      }
    },
    error: () => {
      this.router.navigateByUrl('/auth/login');
    }
  });
  }
  public finishedAuthCheck = computed<boolean>( () => {
    const authStatus = this.authService.authStatus();
    if ( authStatus === AuthStatus.checking ) {
      return false;
    } else if ( authStatus === AuthStatus.notAuthenticated ) {
      this.router.navigateByUrl('/auth/login');
      return true;
    }

    return true;
  });

  public themeMode() {
    if (localStorage.getItem('theme') === 'dark' || (localStorage.getItem('theme') === null && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }

  public setupDarkModeListener() {
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    darkModeMediaQuery.addEventListener('change', (_e) => {
      this.themeMode(); // Actualizar el modo de tema cuando cambie la preferencia de color
    });
  }


  public authStatusChangedEffect = effect(() => {

    switch( this.authService.authStatus() ) {

      case AuthStatus.checking:
        return;

      case AuthStatus.authenticated:
        // Verificar si los servicios ya han sido inicializados
        if (!this.servicesInitialized) {
          this.initializeServices();
        }
        return;

      case AuthStatus.notAuthenticated:
        this.router.navigateByUrl('/auth/login');
        return;
    }
  });

  private initializeServices() {
    if (!this.servicesInitialized) {
      this.usersService.initialize();
      this.typeDocIDService.initialize();
      this.requestStatusService.initialize();
      this.servicesInitialized = true;
    }
  }


  // El decorador @HostListener detecta eventos en el documento, en este caso, resize
  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.themeMode(); // Actualizar el modo de tema cuando cambie el tamaño de la ventana
  }

}
